import { ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { GoDialogRef } from '@go-modules/services/go-dialog-ref/go-dialog-ref';
import { GO_MODAL_DATA } from '@go-modules/services/go-modal/go-modal.tokens';
import { CourseFolder } from '@go-modules/services/course/interfaces/course-folder.interface';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { UniqueIdGeneratorUtil } from '@go-modules/utilities/unique-id-generator/unique-id-generator.util';

@Component({
	selector: 'copy-activities-dialog',
	templateUrl: './copy-activities-dialog.component.html',
	styleUrls: ['./copy-activities-dialog.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [TranslatePipe],
	standalone: false
})
export class CopyActivitiesDialogComponent implements OnInit, OnDestroy {
	public dialogTitleId = `copy-activities-dialog-title-${UniqueIdGeneratorUtil.getId()}`;
	public form = new UntypedFormGroup({
		shouldCopy: new UntypedFormControl(false),
		folder: new UntypedFormControl(null)
	});
	private shouldCopySubscription: Subscription;

	constructor (
		public dialogRef: GoDialogRef,
		@Inject(GO_MODAL_DATA) public data: {
			availableFolders: CourseFolder[];
		}
	) {}

	public ngOnInit () {
		this.shouldCopySubscription = this.form
			.get('shouldCopy')
			.valueChanges.subscribe((value) => {
				if (value) {
					this.form.get('folder').setValidators([Validators.required]);
				} else {
					this.form.get('folder').clearValidators();
				}
				this.form.get('folder').updateValueAndValidity();
			});
	}

	public ngOnDestroy () {
		if (this.shouldCopySubscription) {
			this.shouldCopySubscription.unsubscribe();
		}
	}

	public cancel () {
		this.dialogRef.close(null);
	}

	public confirm () {
		if (this.form.valid) {
			this.dialogRef.close(this.form.value.folder);
		}
	}
}
